<template>
  <section id="depoimentos">
    <h2>Depoimentos</h2>
    <div class="slider-container">
      <tiny-slider v-bind="tinySliderOptions">
        <div class="slide">
          <div class="card">
            <p><q>
              Estava buscando uma empresa que tivesse foco em capacitar para o mercado de trabalho. Fiz diversos cursos e hoje me sinto uma profissional atualizada, lado a lado com a SAMATech.
              </q>
              <br>
              <span class="cite-name">Jéssica Mendonça</span>
            </p>
            <div class="quote-img">
              <img src="../../assets/img/left-quote.svg" alt="">
            </div>
          </div>
        </div>
        
        <div class="slide">
          <div class="card">
            <p><q>
              A SAMATech me fez crescer profissionalmente, ganhar experiência e confiança para conquistar novos horizontes. Facilitou o caminho que eu já buscava de dar aulas.
              </q>
              <br>
              <span class="cite-name">Geicivane Cotrin</span>
            </p>
            <div class="quote-img">
              <img src="../../assets/img/left-quote.svg" alt="">
            </div>
          </div>
        </div>

        <div class="slide">
          <div class="card">
            <p><q>
              A SAMATech estava no lugar certo na hora certa para ajudar de forma fundamental no meu crescimento profissional. Pra mim foi uma fonte de profissionalismo e amizade.
              </q>
              <br>
              <span class="cite-name">George Alves</span>
            </p>
            <div class="quote-img">
              <img src="../../assets/img/left-quote.svg" width="40" alt="">
            </div>
          </div>
        </div>

        <div class="slide">
          <div class="card">
            <p><q>
              Eu amei o curso. Pelo tempo que estava parada, foi muito bom relembrar e aprender coisas novas. Parabenizo os professores pelo empenho com os alunos e por passar segurança na hora dos procedimentos.
              </q>
              <br>
              <span class="cite-name">Rosana Mendonça</span>
            </p>
            <div class="quote-img">
              <img src="../../assets/img/left-quote.svg" width="40" alt="">
            </div>
          </div>
        </div>

        <div class="slide">
          <div class="card">
            <p><q>
              O curso proporciona uma visão realista do cotidiano de um ambiente hospitalar, mostrando que um dia é sempre diferente do outro e o profissional deve saber atuar nessas situações estando atento para soluções rápidas e adequadas. Espero ter a oportunidade de participar de outros cursos.
              </q>
              <br>
              <span class="cite-name">Carolina Oliveira</span>
            </p>
            <div class="quote-img">
              <img src="../../assets/img/left-quote.svg" width="40" alt="">
            </div>
          </div>
        </div>

        <div class="slide">
          <div class="card">
            <p><q>
              Só tenho a agradecer a SAMATech pelo cursos, superou minhas expectativas, adorei a didática, sem falar nos professores que a todo tempo estão incentivando, orientando, corrigindo com dedicação. Tive muita prática, estou satisfeita e com meus objetivos alcançados.
              </q>
              <br>
              <span class="cite-name">Fernanda de Azevedo Abreu</span>
            </p>
            <div class="quote-img">
              <img src="../../assets/img/left-quote.svg" width="40" alt="">
            </div>
          </div>
        </div>
      </tiny-slider>
      <div id="slider-controls">
        <img src="../../assets/img/left-arrow.svg" width="40" alt="Anterior">
        <img src="../../assets/img/right-arrow.svg" width="40" alt="Próximo">
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
#depoimentos {
  background: $color-logo-2;
  padding: 2em 0 4em 0;
}
.slider-container {
  width: 100%;
  position: relative;
}
h2 {
  color: white;
}
.card {
  background: white;
  box-sizing: border-box;
  max-width: 1300px;
  min-height: 270px;
  padding: 2em 4em;
  width: 80%;
  @media (max-width: 650px) {
    width: 95%;
  }
  @media (max-width: 420px) {
    padding-right: 1em;
    padding-left: 1em;
  }
  box-shadow: 1px 2px 3px #555;
  margin: 5px auto;
  border-radius: 4px;
  text-align: center;
  position: relative;
  display: flex;
  align-items: center;
  p {
    width: 100%;
  }
  q {
    font-size: 1.6rem;
    @media (max-width:900px) {
      font-size: 1.4rem;
    }
    @media (max-width:400px) {
      font-size: 1.2rem;
    }
    &::before, &::after {
      content: "";
    }
  }
  .cite-name {
    font-size: 1.4rem;
    margin-top: 1.5em;
    @media (max-width:900px) {
      font-size: 1.2rem;
    }
    @media (max-width:400px) {
      font-size: 1.1rem;
    }
    display: block;
    /* text-align: right; */
    font-style: italic;
  }
  .quote-img {
    width: 40px;
    position: absolute;
    left: 0.6em;
    top: 0.4em;
    background: white;
    opacity: 0.5;
    img {width: 100%; }
  }
}
#slider-controls {
  img {
    width: 50px;
    position: absolute;
    top: calc(50% - 25px);
    @media (max-width: 650px) {
      display: none;
    }
    &:first-child {
      left: 2.5%;
    }
    &:last-child {
      right: 2.5%;
    }
  }
}

</style>
<script>
export default {
  data() {
    return {
      tinySliderOptions: {
        autoplay: true,
        speed: 500,
        autoplayButtonOutput: false,
        mouseDrag: true,
        loop: true,
        items: 1,
        controlsContainer: '#slider-controls'
      }
    }
  }
}
</script>
